function eachAxis(callback) {
    return [callback("x"), callback("y")];
}

export { eachAxis };
//# sourceMappingURL=each-axis.mjs.map
